import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getBrandApi } from "../../services/Api/BrandApi"
import { getErrors, getBrandsSuccess } from "../reducers/BrandReducer"

// Watchers
function* brandSaga() {
	yield takeEvery("brands/getBrands", getBrand)
}

// Sagas
function* getBrand(action) {
	try {
		const getBrand_response = yield call(getBrandApi, action.payload)

		if (getBrand_response.request.status == 200) {
			yield put(getBrandsSuccess(getBrand_response))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(brandSaga)])
}
